import { render, staticRenderFns } from "./FiltersGrid.vue?vue&type=template&id=179803d0&"
import script from "./FiltersGrid.vue?vue&type=script&lang=ts&"
export * from "./FiltersGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports